import { Carousel, Image } from "antd";
import { useRef, useState } from "react";
import { TaxAdvert } from "../types";


export default function AdvertImageGallery({ advert }: { advert: TaxAdvert }) {
  const [visible, setVisible] = useState(false)
  const currentIndexRef = useRef(0)

  function handleSetVisible(index: number) {
    setVisible(true);
    currentIndexRef.current = index;
  }

  const draggedRef = useRef(false);
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const DRAG_THRESHOLD = 6; // px

  function onPointerDown(e: React.PointerEvent) {
    draggedRef.current = false;
    startXRef.current = e.clientX;
    startYRef.current = e.clientY;
  }

  function onPointerMove(e: React.PointerEvent) {
    const dx = Math.abs(e.clientX - startXRef.current);
    const dy = Math.abs(e.clientY - startYRef.current);
    if (dx + dy > DRAG_THRESHOLD) draggedRef.current = true;
  }

  function onImageClick(index: number) {
    // if we dragged, swallow the click
    if (draggedRef.current) return;
    handleSetVisible(index);
  }


  return (
    <div>
      <Carousel
        infinite
        centerMode
        slidesToShow={3}
        draggable
        swipeToSlide
        variableWidth={false}
        waitForAnimate={true}
        className="model-catalog-image-carousel"
        lazyLoad="progressive"
      >
        {advert.images?.map((image, index) => (
          <div key={index}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onClick={(e) => {
              // prevent bubbling to anything else
              e.stopPropagation();
              onImageClick(index);
            }}
          >
            <Image preview={{ visible: false, }} draggable={false} src={image} />
          </div>
        ))}
      </Carousel>

      <Image.PreviewGroup preview={{
        visible: visible,
        onVisibleChange: vis => setVisible(vis),
        current: currentIndexRef.current,
      }}>
        <div style={{ display: "none" }}>
          {advert.images?.map((image, index) => (
            <Image key={index} src={image} />
          ))}
        </div>
      </Image.PreviewGroup>
    </div>

  )
}
